import { useMutation } from '@apollo/client';
import { Pricing } from '../../shared/types';
import { CITRIN_CREATE_PRICING, CreatePricingRequest, CreatePricingResponse } from '..';

type CreateMutationFunction = (request: Pricing) => Promise<Pricing>;
export const useCreatePricingMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreatePricingResponse, CreatePricingRequest>(CITRIN_CREATE_PRICING);

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createPricing;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
